import { useEffect } from 'react';
import { useRouteHelper } from './use-route-helper';
import { autorun, when } from 'mobx';

import { useStore } from 'core/store';
import { get, policyTypes } from 'core/helpers/lookups';

const getPolicyType = get(policyTypes);

export const useTabText = () => {
  const {
    inPolicyRoute,
    inOfferEditRoute,
    inUWFormRoute,
    inOfferCheckoutRoute,
    inCustomerRoute,
    inNewQuoteRoute,
    inToolsRoutes,
    inSearchOffers,
    inSearchCustomers,
    inSearchPolicies,
    inAgencyPortal,
    inSignInRoute,
    inBranchPlusPolicy
  } = useRouteHelper();
  const { offer: offerStore, account: accountStore, branchPlus: branchPlusStore } = useStore();
  const { policies: policesStore } = accountStore;
  const { policy: policyStore } = policesStore;

  return useEffect(() =>
    autorun(async () => {
      if (inOfferEditRoute || inOfferCheckoutRoute || inUWFormRoute) {
        await when(() => !offerStore?.isLoading && offerStore?.primaryNamedInsured);
        if (offerStore?.primaryNamedInsured) {
          document.title = 'Branch Offer For ' + offerStore?.primaryNamedInsured;
        } else {
          document.title = 'Branch Offer';
        }
      } else if (inNewQuoteRoute) {
        document.title = 'Branch New Offer';
      } else if (inPolicyRoute) {
        await when(() => !accountStore?.accountLoading && !policyStore?.loading && policyStore?.policy?.policyType);
        if (accountStore?.fname && accountStore?.lname) {
          if (policyStore?.policyType) {
            document.title = `Branch ${getPolicyType(policyStore?.policy?.policyType)} Policy For ${accountStore.fname} ${accountStore.lname}`;
          } else {
            document.title = `Branch Policy For ${accountStore?.fname} ${accountStore?.lname}`;
          }
        } else {
          document.title = 'Branch Policy';
        }
      } else if (inBranchPlusPolicy) {
        await when(() => !branchPlusStore?.loading && branchPlusStore?.branchPlusPolicy);
        if (branchPlusStore?.branchPlusPolicy && branchPlusStore?.branchPlusPolicy?.customer) {
          document.title = `Branch Plus Policy For ${branchPlusStore?.branchPlusPolicy?.customer?.firstName} ${branchPlusStore?.branchPlusPolicy?.customer?.lastName}`;
        } else {
          document.title = 'Branch Plus Policy';
        }
      } else if (inCustomerRoute) {
        await when(() => !accountStore?.accountLoading);
        if (accountStore?.fname && accountStore?.lname) {
          document.title = `Branch Member ${accountStore?.fname} ${accountStore?.lname}`;
        } else {
          document.title = 'Branch Member';
        }
      } else if (inToolsRoutes) {
        document.title = 'Branch Internal Tools';
      } else if (inSearchOffers) {
        document.title = 'Branch Search Offers';
      } else if (inSearchCustomers) {
        document.title = 'Branch Search Members';
      } else if (inSearchPolicies) {
        document.title = 'Branch Search Policies';
      } else if (inAgencyPortal) {
        document.title = 'Branch Portal';
      } else if (inSignInRoute) {
        document.title = 'Branch Sign In';
      } else {
        document.title = 'Branch Staff App';
      }
    })
  );
};
